<div
  class="flex justify-between items-center gap-2 border rounded-md min-h-14 w-full pl-4 pr-1"
  [ngClass]="{ 'opacity-70': disabled, 'hover:border-gray-200': !disabled, '!border-primary-400': invalid }">
  <div class="flex items-center gap-2 flex-1 overflow-hidden">
    @if (error?.length) {
      <mat-icon
        svgIcon="remix:System/error-warning-line"
        class="min-w-[24px]" />
    } @else {
      <mat-icon
        [svgIcon]="fileIcon ? fileIcon : 'remix:Editor/attachment-2'"
        class="min-w-[24px]" />
    }

    <p
      class="text-base font-bold truncate"
      [matTooltip]="file.name"
      [matTooltipDisabled]="file.name.length < 30"
      matTooltipPosition="above">
      {{ file.name }}
    </p>

    @if (error?.length) {
      <span
        class="text-xs text-primary-800 pt-[3px] whitespace-nowrap"
        translate>
        {{ error }}
      </span>
    } @else {
      <span class="text-xs pt-[3px] opacity-50 whitespace-nowrap">{{ file.size | fileSize }}</span>
    }
  </div>

  <div>
    @if (url) {
      <button
        type="button"
        mat-icon-button
        [disabled]="deleteLoading"
        (click)="download.emit()">
        @if (downloadLoading) {
          <mat-spinner
            class="block"
            diameter="24"
            mode="indeterminate" />
        } @else {
          <mat-icon svgIcon="remix:System/download-cloud-line" />
        }
      </button>
    }

    @if (allowEdit) {
      <button
        type="button"
        mat-icon-button
        [disabled]="disabled || editDisabled || editLoading"
        (click)="edit.emit()">
        @if (editLoading) {
          <mat-spinner
            class="block"
            diameter="24"
            mode="indeterminate" />
        } @else {
          <mat-icon svgIcon="remix:Design/edit-line" />
        }
      </button>
    }

    @if (allowDelete) {
      <button
        type="button"
        mat-icon-button
        [disabled]="disabled || deleteDisabled || deleteLoading || downloadLoading"
        (click)="delete.emit()">
        @if (deleteLoading) {
          <mat-spinner
            class="block"
            diameter="24"
            mode="indeterminate" />
        } @else {
          <mat-icon svgIcon="remix:System/delete-bin-line" />
        }
      </button>
    }
  </div>
</div>
